import { DataItem } from 'scrivito';

export async function formatDataItemSummary(
  item: DataItem,
): Promise<Record<string, unknown>> {
  // TODO skip all empty attributes (save tokens)
  // TODO resolve references (e.g. 'responsibleAgent' from ID to data)

  // @ts-expect-error getExternalData is not public in the SDK
  const { systemData, customData } = item.getExternalData();

  return {
    _id: systemData._id,
    // TODO abstract, don't hardcode for activity
    _summary: `${customData.activityType}: ${customData.subject}`,
  };
}

export async function formatDataItemDetails(
  item: DataItem,
): Promise<Record<string, unknown>> {
  // TODO skip all empty attributes (save tokens)
  // TODO resolve references (e.g. 'responsibleAgent' from ID to data)

  // @ts-expect-error getExternalData is not public in the SDK
  const raw = item.getExternalData();

  return {
    _id: raw.systemData._id,
    // _url: await load(() => urlForDataItem(item)),

    ...raw.customData,
  };
}
